var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-chat-floating"},[_c('div',{staticClass:"photo-container"},[_c('img',{staticClass:"my-photo",attrs:{"src":_vm.photoUrl.me,"alt":""}}),_c('img',{staticClass:"user-photo",attrs:{"src":_vm.photoUrl.user,"alt":""}})]),_c('div',{staticClass:"schedule f-14 spoqa-f-regular c-black",domProps:{"innerHTML":_vm._s(_vm.schedule)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }